import superadminSidebarItems from './superadminSidebarItems';
import tenantSidebarItems from './tenantSidebarItems';

export default { tenantSidebarItems, superadminSidebarItems };
